import React from "react";
import { Link } from "react-router-dom";

import * as Middleware from "@middlewares/index";

const NewWebinars: React.FC = () => {
  return (
    <div className="modal modal--new-webinars">
      <div className="modal__body">
        <div className="modal__title">Не пропустите новые вебинары!</div>
        <div className="modal__desc">
          В расписании появились новые вебинары, возможно, там именно те
          направления, которые вас заинтересуют.
        </div>
        <Link
          to="/?anchor=schedule-anchor"
          className="btn btn--yellow btn--large"
          onClick={() => {
            Middleware.Ui.Modal.close();
          }}
        >
          Перейти -net
        </Link>
      </div>
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
    </div>
  );
};

export default NewWebinars;
